import React from 'react';

interface PensIconProps {
	size?: number;
}

export const PensIcon = ({ size = 24 }: PensIconProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M40.5834 12.4787V11.4679C40.5834 10.4416 39.7509 9.60904 38.7245 9.60904C37.6982 9.60904 36.8656 10.4416 36.8656 11.4679L36.8655 34.6931H40.5152V22.447C40.7101 22.3333 40.8416 22.1221 40.8416 21.8797V12.4787H40.5834Z"
				fill="#1868DB"
			/>
			<path
				d="M36.8672 33.2949H40.517V36.517C40.517 37.5241 39.6983 38.3427 38.6912 38.3427C37.6841 38.3427 36.8655 37.5241 36.8655 36.517V33.2949H36.8672Z"
				fill="#09326C"
			/>
			<path d="M40.0841 12.5274H39.5291V19.5895H40.0841V12.5274Z" fill="#09326C" />
			<path
				d="M30.1165 14.1508L31.4722 10.131L32.8278 14.1508H32.8301V37.264H31.9225V38.2101H30.973V37.264H30.116V14.1508H30.1165Z"
				fill="#292A2E"
			/>
			<path d="M26.0772 14.732H22.4275V38.4405H26.0772V14.732Z" fill="#FCA700" />
			<path d="M26.4852 36.997H22.0186V38.5854H26.4852V36.997Z" fill="#BF63F3" />
			<path d="M26.0772 36.997H22.4275V38.4405H26.0772V36.997Z" fill="#AE2A19" />
			<path
				d="M23.4919 9.84648H25.0122V10.8868H26.8518L26.3526 16.3797H22.1635L21.666 10.8868H23.4919V9.84648Z"
				fill="#BF63F3"
			/>
			<path d="M26.0772 14.7145H22.4275V16.3797H26.0772V14.7145Z" fill="#AE2A19" />
			<path
				d="M16.0303 10.5813V9.92496L17.1003 9.52176V10.5813H17.3271V11.9173C17.9504 12.208 18.3832 12.8407 18.3832 13.573V16.4634H18.3812V38.4405H14.7314V15.8194H14.7335V13.573C14.7335 12.8415 15.1653 12.2094 15.7876 11.9183V10.5813H16.0303Z"
				fill="#1868DB"
			/>
			<path
				d="M13.9373 26.2204C13.6598 26.3984 13.7331 26.5782 14.0438 26.4298C14.152 26.3774 14.262 26.3233 14.3754 26.2675C14.4802 26.2134 14.5884 26.1593 14.7123 26.1069C14.9532 26.0004 15.2098 25.8852 15.5013 25.7735C15.8294 25.6426 16.0354 25.5815 16.2186 25.5396C16.4002 25.4977 16.5608 25.4803 16.7842 25.5117C16.9727 25.5379 17.1821 25.6182 17.3637 25.7613C17.4056 25.7997 17.4492 25.8398 17.4928 25.88C17.533 25.9219 17.5644 25.9655 17.5993 26.0092C17.6569 26.1034 17.704 26.2029 17.7285 26.3111C"
				fill="#164B35"
			/>
			<path
				d="M14.0262 24.3566C13.918 24.5207 14.0838 24.6272 14.2078 24.5067C14.3963 24.3304 14.5918 24.1349 14.8291 23.8731C15.091 23.5694 15.1294 23.4699 15.3161 23.2709C15.6268 22.9323 16.1923 22.3982 16.3285 22.2708C16.3494 22.2516 16.3686 22.2324 16.3861 22.2115C16.5153 22.0613 17.0825 21.4033 17.6027 20.864C17.9622 20.4765 18.1839 20.2356 18.2991 20.1117C18.5732 19.8149 18.7634 19.5811 18.9362 19.3349C19.0392 19.1883 18.8961 19.0941 18.7809 19.1936C18.5557 19.3856 18.334 19.5933 18.06 19.8883C"
				fill="#164B35"
			/>
			<path
				d="M14.042 19.7396C13.9285 19.8495 14.0594 19.9944 14.1816 19.9298C14.3614 19.8356 14.5534 19.7291 14.7873 19.5773C15.0491 19.3957 15.0945 19.3189 15.2778 19.2072C15.585 19.01 16.133 18.7272 16.2657 18.6591C16.2849 18.6487 16.3041 18.6382 16.3215 18.626C16.4507 18.5352 17.018 18.1425 17.5276 17.8388C17.882 17.6154 18.1019 17.4775 18.2171 17.4042C18.4876 17.2314 18.6796 17.0882 18.8594 16.9294C18.9676 16.8317 18.8542 16.706 18.746 16.7531C18.5295 16.8491 18.3166 16.9591 18.0443 17.1284C17.9"
				fill="#164B35"
			/>
			<path d="M17.102 10.5813H16.0303V11.5343H17.102V10.5813Z" fill="#09326C" />
			<path d="M7.51953 14.1734L9.34528 9.4258L11.1693 14.1734H7.51953Z" fill="#FCA700" />
			<path d="M7.51953 14.1734H11.1693V34.693H7.51953V14.1734Z" fill="#FCA700" />
			<path
				d="M7.51957 33.2949H11.1693V36.517C11.1693 37.5241 10.3507 38.3427 9.34357 38.3427C8.33644 38.3427 7.51782 37.5241 7.51782 36.517V33.2949H7.51957Z"
				fill="#BF63F3"
			/>
			<path d="M9.99599 11.1206L9.34494 9.4258L8.69214 11.1206H9.99599Z" fill="#292A2E" />
			<path d="M11.5339 33.1553H7.15625V34.8309H11.5339V33.1553Z" fill="#1868DB" />
			<path d="M11.1693 33.1553H7.51953V34.8309H11.1693V33.1553Z" fill="#164B35" />
		</svg>
	);
};
